export default __webpack_public_path__ + "static/media/2.d37220e0.mp4";